<div style="display: flex;">
    <img style="cursor: pointer;margin-left: auto;" (click)="onNoClick()" src="assets/close-copy.svg">
</div>

<div>
    Copy and Share url <br><br>

    {{copyURLData}}  <button class="btn btn-primary" (click)="copy()">copy</button>
</div>